<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>
      <h2 class="page-title">My Sites</h2>

      <b-row v-if="websites">
        <b-col>
          <Widget
          ><div class="table-responsive">
            <table class="table table-hover table-sm" >
              <thead>
              <tr>
                <th scope="col">Site</th>
                <th scope="col">Last Check</th>
                <th scope="col">Schedule</th>
                <th scope="col">Pages</th>
                <th scope="col">Report</th>
                <th scope="col">Edit</th>

              </tr>
              </thead>
              <tbody>
              <tr v-if="websites.length === 0">
                <td colspan="6">
                  <b-alert show variant="info">You have not added any sites yet.</b-alert>
                </td>
              </tr>

              <tr class="spelling" v-for="(website, index) in websites">
                <template v-if="website.websites_crawls.length > 0">
                <td width="75%" class="link-entry"  style="vertical-align:middle">
                  <a :href="website.url" target="_blank">
                    <span v-if="activeSite.uuid === website.uuid"><b>{{website.url}}</b></span>
                    <span v-else>{{website.url}}</span>
                  </a>
                </td>
                <td width="35%" style="vertical-align:middle">
                {{website.websites_crawls[0].completed_at | moment('from')}}
                </td >
                <td v-if="!website.demo" style="vertical-align:middle" nowrap>
                  <div v-if="website.recurring_schedule">
                  {{website.recurring_schedule | capitalize}}
                  </div>
                  <div v-else style="color:#A9A9A9" >
                    Manual
                  </div>
                </td>
                <td v-else  style="vertical-align:middle" >
                  <div style="color:#A9A9A9" >
                  Demo
                </div></td>
                <td v-if="!website.demo" style="vertical-align:middle">
                  {{website.max_crawl_pages}}
                </td>
                <td v-else></td>
                <td >
                  <b-button size="sm" style="white-space: nowrap;" @click="selectSite(website)">View Report</b-button>
                </td>
                <td nowrap v-if="!website.demo" style="vertical-align:middle" >
                  <router-link :to="{ name: 'NewPage', query: {site: website.id} }" title="Edit"><i class="fa fa-edit"></i></router-link> &nbsp;
                  <span><a href="" @click.prevent="deleteSite(website)" title="Delete Site"><i class="fa fa-trash"></i></a></span>

                </td>
                  <td v-else> </td>
                </template>
              </tr>
              </tbody>
            </table>
          </div>
          </Widget>
        </b-col>
      </b-row>
      <b-button variant="info" size="sm" class="ml-1" style="white-space: nowrap;" :to="{ name: 'NewPage' }">New Site</b-button>
    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import gql from "graphql-tag";
  import { ApolloClient } from "apollo-client";
  import DemoNotice from "@/components/DemoNotice/DemoNotice";

  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget, DemoNotice },
    apollo: {
      $subscribe: {
        websites: {
          query() {
            return gql`subscription {
      websites: websites_website(where: {deleted: {_eq: false}}, limit: 200, order_by: {id: desc}) {
        id
        uuid
        url
        demo
        recurring
        recurring_schedule
        uuid
        max_crawl_pages
        websites_crawls(order_by: {completed_at: desc}, limit: 1){
          id
          stats
          completed_at
          max_pages
          pages_used
        }
      }
    }`
          },
          result(data, b) {
            this.websites = data.data.websites;
            if (this.websites.length > 1){
              let demoIndex = this.websites.findIndex((w)=> { return w.demo; });
              if (demoIndex !== -1) {
                this.websites.splice(demoIndex, 1)
              }
            }
            this.loading = false;
          }
        },
      },
    },
    data() {
      return {
        websites: [],
        plan: {},
        toastOptions: {
          theme: 'dark',
          position: 'bottomLeft',
        },
        loading: true,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite', user: 'user'}),
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'My Sites - PageWatch.dev',
      // all titles will be injected into this template
    },
    methods: {
      deleteSite(site){

        const h = this.$createElement;
        const titleVNode = h('div', {domProps: {innerHTML: `This will delete the site and all historical data<br>Are you sure you want to continue?.`}});
        this.$bvModal.msgBoxConfirm([titleVNode], {
          title: 'Delete Site',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete Site',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
                .then(ok => {
                  if (ok) {
                    axios
                            .delete(`websites/update/${site.uuid}`)
                            .then(
                                    response => {
                                      this.$root.$emit("websites-reload");
                                      return true;

                                    },
                                    _response => {
                                      console.warn(_response);
                                      return false;
                                    }
                            );
                  }
                })






      },
      selectSite(site){

        axios
                .put(`websites/active/${site.uuid}`)
                .then(
                        response => {
                          // this.$store.commit("setActiveSite", site);
                          this.$router.push({ name: "Dashboard" });
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );

      },
      cancelSubscription(website) {
        const h = this.$createElement;
        const titleVNode = h('div', {domProps: {innerHTML: `<div class="alert alert-danger" role="alert">This will stop the automatic audits for this website.</div>`}});
        this.$bvModal.msgBoxConfirm([titleVNode], {
          title: 'Cancel recurring audits',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Stop Subscription',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
                .then(ok => {
                  if (ok) {

                    axios
                            .put(`websites/cancel/${website.uuid}`)
                            .then(
                                    response => {
                                      website.recurring = false
                                      return true;
                                    },
                                    _response => {
                                      alert('We were not able to stop the subscription, please contact support')
                                      return false;
                                    }
                            );

                  }
                })

      }

    },
    created() {
      this.$watch("$route",() => { this.currentPage = this.$route.query.page || 1}, {
        immediate: true
      });
    },
    mounted(){
      if (this.user.role !== 'user'){
        this.$router.push({ name: "Dashboard" });
      }
    }
  };
</script>

<style src="./Websites.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
